import styled from 'styled-components/macro'
import { Grid } from '../../components/layout'

export const LoginWrapper = styled(Grid)`
  min-height: 100vh;
  height: 100%;
`
